import React from "react";

export default function Kyochon() {
  return <div></div>;
}
